import * as types from '../actions/types';

const initialState = {
    category: "upcoming",
    success: false
}

export default function TrainingdataTypeReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.TRAINING_DATA_FILTER:
            return {
                ...state,
                category: action.payload,
                success: true
            }
        default:
            return state
    }
}
